/* ════════════════════════════════════════════════════════════════════════════
 * KAGAKI — Loved in Quiet Moments — Testimonial Carousel
 * Version: 1.0 (2026-05-17)
 *
 * Vanilla JS (no jQuery, no library). Uses native CSS scroll-snap for
 * touch swipe. The buttons only smooth-scroll the track by one card width.
 *
 * Multiple sections on the same page are supported; each initializes
 * independently.
 * ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function init() {
    var sections = document.querySelectorAll('.kg-testimonials');
    sections.forEach(initSection);
  }

  function initSection(section) {
    var track = section.querySelector('[data-kg-track]');
    var prevBtn = section.querySelector('[data-kg-prev]');
    var nextBtn = section.querySelector('[data-kg-next]');

    if (!track) return;

    function getCardStep() {
      var card = track.querySelector('.kg-testimonial-card');
      if (!card) return track.clientWidth;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseInt(trackStyle.columnGap || trackStyle.gap || '0', 10) || 0;
      return card.offsetWidth + gap;
    }

    function scrollByCards(direction) {
      var step = getCardStep();
      track.scrollBy({
        left: direction * step,
        behavior: 'smooth'
      });
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= max - 1;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { scrollByCards(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { scrollByCards(1); });
    }

    // Keyboard support (left/right arrows when track is focused or hovered)
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollByCards(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollByCards(1);
      }
    });

    // Make track focusable for keyboard users (without changing visual focus ring on inner cards)
    if (!track.hasAttribute('tabindex')) {
      track.setAttribute('tabindex', '0');
    }

    track.addEventListener('scroll', updateButtons, { passive: true });

    // Recompute on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateButtons, 120);
    });

    // Initial state
    updateButtons();
  }

  // Init on DOMContentLoaded and on Shopify section reload (theme editor)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load events (theme editor live preview)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.kg-testimonials');
    if (section) initSection(section);
  });
})();
